export enum UserPermission {
	MAAS_BILLING = 'maas-billing',
}
